import {Component, OnInit, ViewChild} from '@angular/core';
import {TimelineComponent} from "../../elements/timeline/timeline.component";
import {SliderHorizontalComponent} from "../../elements/slider-horizontal/slider-horizontal.component";
import {Article} from "../../../model/article";
import {ActivatedRoute} from "@angular/router";
import {ChronologyService} from "../../../services/chronology-service";
import {ApiService} from "../../../services/api.service";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-chronology',
    imports: [
        TimelineComponent,
        SliderHorizontalComponent,
        NgIf
    ],
    templateUrl: './chronology.component.html',
    styleUrl: './chronology.component.scss',
    standalone: true,
})
export class ChronologyComponent implements OnInit {
    constructor(private route: ActivatedRoute,
                private chronologyService: ChronologyService,
                private apiService: ApiService

    ) {
    }

    @ViewChild(SliderHorizontalComponent) sliderHorizontalComponent!: SliderHorizontalComponent;
    @ViewChild(TimelineComponent) timelineComponent!: TimelineComponent;

    activeYear: number = 0;
    activeMonth: number = 1;

    articles: Article[] = [];
    sortedArticles: Article[] = [];
    loading: boolean = false;


    ngOnInit() {
        this.loading = true;
        this.apiService.getPaginatedData('public/chronology', 1, 1000, '').subscribe((data) => {
            this.articles = data.content.sort((a: any, b: any) => a.orderNumber - b.orderNumber).map((v: any) => new Article(v));
            this.articles.forEach((v) => {
                v.type = 'article';
            })
            this.loading = false;
            this.sortArticles();
            setTimeout(() => {
                this.setActive(this.chronologyService.getActiveChronology());
            }, 100);
        })

    }

    getActive(article: Article) {
        this.chronologyService.setActiveChronology(article.id);
        const id = article.timelineId ?? 0;
        const year = Math.floor(id / 12);
        const month = id % 12;
        this.timelineComponent.sliderSelect(year, month);
    }

    setActive(id: number) {
        const idx = this.articles.findIndex(v => v.id == id);
        if (idx > -1) {
            this.chronologyService.setActiveChronology(id);
            const year = Math.floor(Number(this.articles[idx].timelineId) / 12);
            const month = Number(this.articles[idx].timelineId) % 12;
            this.timelineComponent.sliderSelect(year, month);
            this.sliderHorizontalComponent.setActiveEl(idx);
        } else {
            console.log('not found');
        }
    }

    setActiveByTimeline(timeLineId: number) {
        const idx = this.sortedArticles.findIndex(v => v.timelineId == timeLineId);
        if (idx > -1) {
            this.chronologyService.setActiveChronology(this.sortedArticles[idx].id);
            this.sliderHorizontalComponent.setActiveEl(idx);
        }
    }


    sortArticles() {
        this.sortedArticles = this.articles.sort((a, b) => {
            const timeLineIdA = a.timelineId ?? Number.MAX_VALUE;
            const timeLineIdB = b.timelineId ?? Number.MAX_VALUE;
            return timeLineIdA - timeLineIdB;
        });
    }

    swipe(type: string) {
        this.sliderHorizontalComponent.scrollToElementSwipe(type);
    }

}
